<template>
  <AppModal id="pre-import-rapport" :close-on-backdrop="closeOnBackdrop">

    <template #title>
      <h3 class="text-center mb-5">{{$t($getConst.pages.invoice.rapport_title) | capitalize}}</h3>
    </template>

    <template #content>
      <div class="mx-auto text-center">
        <b-form-group id="client-id" :label="$t($getConst.pages.client.client_name)" label-for="client-name" class="mb-4">
          <multiselect v-if="clients" v-model.trim="client"
                       id="client-name"
                       :options="clients"
                       track-by="id"
                       label="name"
                       :multiple="false" openDirection="bottom"
                       :searchable="true" :close-on-select="true"
                       :max-height="600" :show-no-results="false"
                       :disabled="isLoading"

          >
            <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
          </multiselect>
        </b-form-group>
        <input
          v-if="Object.values(client).length !== 0"
          type="file"
          name="file"
          id="file"
          class="input-file"
          :disabled="isLoading"
          @change="generatePreImportRapport"
        />
        <label for="file" v-if="Object.values(client).length !== 0">
          <i :class="[$getConst.icons.upload, 'mr-2']"/>
          <span v-if="!file">{{$t($getConst.pages.form.choose_file)}}</span>
          <span v-else>{{file.name}}</span>
        </label>
      </div>

      <b-list-group id="success-rapport" v-if="isRapportGenerated" class="my-3">
        <b-list-group-item class="bg-light d-flex justify-content-between align-items-center font-weight-bold">
          {{$t($getConst.pages.invoice.rapport_total_invoices)}}
          <span>{{rapport.invoicesCount}}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          {{$t($getConst.pages.invoice.rapport_invoices_to_create)}}
          <span>{{rapport.invoicesToCreate}}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          {{$t($getConst.pages.invoice.rapport_invoices_to_update)}}
          <span>{{rapport.invoicesToUpdate}}</span>
        </b-list-group-item>
      </b-list-group>

      <b-list-group id="missing-columns" v-if="missingColumns.length > 0" class="my-3">
        <b-list-group-item class="bg-light d-flex justify-content-between align-items-center text-danger">
          <h5>
            <b>{{$t($getConst.pages.invoice.rapport_missing_columns)}}</b>
          </h5>
        </b-list-group-item>
        <b-list-group-item v-for="column in missingColumns"
                           class="justify-content-between align-items-center font-weight-bold">
          {{ column }}
        </b-list-group-item>
      </b-list-group>

      <b-list-group id="pending-response" v-if="reportIsPending" class="my-3">
        <b-list-group-item class="d-flex justify-content-between align-items-center text-success">
          <h5>
            <b>{{$t($getConst.pages.invoice.rapport_invoices_is_pending)}}</b>
          </h5>
        </b-list-group-item>
      </b-list-group>

      <b-list-group class="mb-3" v-if="rapport.timesheetsToCreate.length > 0">
        <a type="button" v-b-toggle="'row-timesheets'"
           class="bg-warning list-group-item d-flex justify-content-between align-items-center py-2 px-4">
          {{$t($getConst.pages.invoice.rapport_timesheets_not_found)}}
          ({{rapport.timesheetsToCreate.length}})
          <span><i :class="$getConst.icons.chevron_down"/></span>
        </a>
        <b-collapse id="row-timesheets" accordion="my-accordion" class="list-group-item">
          <ul class="mb-0">
            <li v-for="timesheet in rapport.timesheetsToCreate">
              {{timesheet}}
            </li>
          </ul>
        </b-collapse>
      </b-list-group>

      <b-list-group id="failed-rapport" v-else-if="failedResponse" class="overflow-auto">
        <b-list-group-item class="d-flex bg-light justify-content-between align-items-center text-danger">
          <h5>
            <b>{{$t($getConst.pages.invoice.rapport_total_invalid_invoices)}}</b>
          </h5>
          <span class="badge badge-danger badge-pill w-auto">{{Object.keys(failedResponse).length}}</span>
        </b-list-group-item>
        <template v-for="(errors, row) in failedResponse">
          <a type="button" v-b-toggle="'row-'+row" class="list-group-item d-flex justify-content-between align-items-center py-2 px-4">
            {{$t($getConst.pages.invoice.rapport_row)}} {{row}}
            <span><i :class="$getConst.icons.chevron_down"/></span>
          </a>
          <b-collapse :id="'row-'+row" accordion="my-accordion" class="list-group-item">
            <ul class="mb-0">
              <li v-for="error in errors">
                {{Object.keys(error)[0]}}:
                <span class="float-right">{{$t($getConst.pages.invoice["rapport_"+Object.values(error)[0]])}}</span>
              </li>
            </ul>
          </b-collapse>

        </template>
      </b-list-group>

      <b-progress v-if="isLoading" class="mx-auto w-75" show-progress animated variant="secondary" height="3rem">
        <b-progress-bar class="font-weight-bold font-size-md" :value="uploadPercentage" :label="`${uploadPercentage}%`"/>
      </b-progress>
    </template>

    <template v-if="isRapportGenerated || reportIsPending" #button>
      <AppConfirmButtons
        :submit-text="submitButtonText"
        :is-loading="isLoading"
        @onSubmit="submitInvoicesReport"
        @onCancel="closeModal"
      />
    </template>
  </AppModal>
</template>

<script>
  import AppModal from "../../../components/common/modals/AppModal";
  import {getPreImportRapport, uploadExcel} from "../../../api/invoices.api";
  import AppConfirmButtons from "../../../components/common/utils/AppConfirmButtons";
  export default {
    name: "PreImportRapportModal",
    components: {AppConfirmButtons, AppModal},
    props: {
      scopeId: null,
      clients:null,
    },
    data() {
      return {
        file: null,
        uploadPercentage: 0,
        isLoading: false,
        isRapportGenerated: false,
        missingColumns: [],
        failedResponse: null,
        reportIsPending: false,
        rapport: {
          timesheetsToCreate: [],
          invoicesToCreate: 0,
          invoicesToUpdate: 0,
          invoicesCount: 0
        },
        client:{},
        closeOnBackdrop: true
      }
    },
    validations: {
      client: {}
    },
    computed: {
      submitButtonText() {
        if (this.reportIsPending) {
          return this.$t(this.$getConst.pages.vendor_timesheets.open_pending_jobs);
        } else {
          return this.$t(this.$getConst.pages.invoice.rapport_import_invoices);
        }
      }
    },
    methods: {
      submitInvoicesReport() {
        if (this.reportIsPending) {
          this.$router.push({name: this.$getConst.routesNames.administration.jobsLogs});
        } else {
          this.isLoading = true;
          this.uploadPercentage = 0;
          uploadExcel(
            this.scopeId,
            this.file,
            (event) => {
              this.uploadPercentage = Math.round(100 * event.loaded / event.total);
            },
            (this.client)?this.client.id:""
          ).then(() => {
            this.uploadPercentage = 0;
            this.isLoading = false;
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
            this.closeModal();
            this.$emit("importedInvoices");
          }).catch((error) => {
            this.uploadPercentage = 0;
            this.isLoading = false;
            this.handleApiError(error);
          });
        }
      },
      generatePreImportRapport(event) {
        this.file = event.target.files[0];
        this.resetRapport();

        if (this.file) {
          this.closeOnBackdrop = false;
          this.isLoading = true;
          getPreImportRapport(
            this.scopeId,
            this.file,
            (event) => {
              this.uploadPercentage = Math.round(100 * event.loaded / event.total);
            },
            (this.client)?this.client.id:""
          ).then(
            (response) => {
              if (response.data.status === "missing_columns") {
                this.missingColumns = response.data.data;
                this.closeOnBackdrop = true;
              }
              else if (response.data.status === "pending") {
                this.reportIsPending = true;
              }
              else if (response.data.status === "failed") {
                this.failedResponse = response.data.data;
                this.closeOnBackdrop = true;
              } else {
                this.rapport = response.data.data;
                this.isRapportGenerated = true;
              }
              this.isLoading = false;
            },
            (error) => {
              this.handleApiError(error);
              this.resetRapport();
              this.isLoading = false;
            }
          )
        }
      },
      resetRapport() {
        this.uploadPercentage = 0;
        this.isRapportGenerated = false;
        this.closeOnBackdrop = true;
        this.reportIsPending = false;
        this.missingColumns = [];
        this.failedResponse = null;
        this.rapport = {
          timesheetsToCreate: [],
          invoicesToUpdate: 0,
          invoicesToCreate: 0,
          invoicesCount: 0
        }
      },
      closeModal() {
        this.$bvModal.hide("pre-import-rapport");
      }
    },
    mounted() {
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        if (modalId === "pre-import-rapport") {
          this.resetRapport();
          this.file = null;
        }
      })
    }
  }
</script>

<style scoped>
  #success-rapport.list-group {
    border-radius: 0 !important;
  }
  #success-rapport.list-group-item {
    border: none !important;
  }
  #failed-rapport {
    max-height: 50vh;
  }
</style>
